// extracted by mini-css-extract-plugin
export default {"LabeledIconButton":"labeledIconButton_LabeledIconButton__H3eqj","button":"labeledIconButton_button__+zqJs","label":"labeledIconButton_label__LQvss"};